import { useEffect } from 'react'

export function useTriggerAnimation(
  shouldTrigger: boolean,
  setHasAnimated: (value: boolean) => void,
  animationDelay: number,
) {
  useEffect(() => {
    if (shouldTrigger) {
      const timer = setTimeout(() => {
        setHasAnimated(true)
      }, animationDelay)

      return () => clearTimeout(timer)
    }
  }, [shouldTrigger, setHasAnimated, animationDelay])
}
